import React, { useState, useEffect } from 'react'
import db from './libs/data-base.js'
import write from './libs/pedidos'
import Inicio from './components/slides/Inicio'
import Precos from './components/Precos'

function App() {
  const [ database, setDatabase] = useState(0)
  const [ table, setTable ] = useState(0)
  const hideCreateTable = 'create-table'


  useEffect(()=>{
    const suporteData = db.suporteIndexedDB()
    // console.log('suporteData ', suporteData.open);
    if (suporteData) {
      setDatabase(1)
      const dataBase = db.createDataBase()
    }else {
      setDatabase(0)
    }
    write.readPedido()
  })
  return (
    <div className="App page-main">
    <Inicio />
    <Precos />
    { database === 1
      ? ''
      : <p>Sentimos muito. Seu navegador não permite fazer compras no site. Atualize ou use um navegador diferente.</p> }
    </div>
  )
}

export default App
